/*
 * @Date: 2021-11-25 11:10:04
 * @LastEditTime: 2021-12-06 12:05:56
 */
import { normalize } from 'csstips'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()
import App from './App'
import { forceRenderStyles } from 'typestyle'
import { prefetchQiankun } from './qiankun'

try {
  prefetchQiankun()
} catch (error) {
  console.log(error)
}

// tslint:disable-next-line
require('babel-polyfill')

normalize()

ReactDOM.render(<App history={history} />, document.getElementById('root') as HTMLElement)

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}

forceRenderStyles()



// WEBPACK FOOTER //
// ./src/index.tsx